<template>
  <div id="VersionComponentInfo" class="version-info-container">
    <div class="version-info-left-part">
      <el-tabs v-model="currentTab" class="detail-tab-container" @tab-click="changeView">
        <el-tab-pane v-for="(tab, index) in tabs" :key="index" :label="tab.label" :name="tab.name">
          <div v-if="tab.name==='2d'" class="tab-container">
            <view-carousel v-if="currentTab === '2d'" :view-list="getThumbnails" class="carousel-content">
              <template #content="{item}">
                <img :src="item" alt="" style="max-width: 80%; max-height: 80%;">
              </template>
            </view-carousel>
          </div>
          <div v-else-if="tab.name === '3d'" class="tab-container">
            <nova-design-three-d v-if="newThreeD" :new-three-d="newThreeD" :show="currentTab === '3d'" :family-type="familyType" />
            <bimface
                v-else
                :key="currentResource.softwareVersion"
                :view-token="viewToken"
                :family-type="selectFamilyTypeName"
                from="COMPONENT"
                :config-buttons="['Home', 'Setting', 'FullScreen']"
                height="100%"
                width="100%"
            />
          </div>
          <div v-else-if="tab.name === 'placeholder'" class="tab-container">
            <placeholder-tab-content />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="showFamilyType" class="version-info-right-part">
      <div class="family-select">
        <span class="family-label">类型</span>
        <el-select v-model="familyType" class="family-value" value-key="id" placeholder="规格" @change="changeFamilyType">
          <el-option
            v-for="item in parameterTypeOptions"
            :key="item.id"
            :label="item.name"
            :value="item"
          />
        </el-select>
      </div>
      <div v-loading="parameterLoading" class="family-parameters">
        <el-collapse v-if="versionParameters.length" v-model="activeGroups" v-loading="familyParamsLoading">
          <el-collapse-item
            v-for="(group,index) in propertyGroups"
            :key="index"
            :title="group.groupName"
            :name="index"
          >
            <ul>
              <li v-for="property in group.groupProperties" :key="property.id" class="property">
                <span class="property-name">{{ property.name }}</span>
                <span class="property-value">{{ property.value || '-' }}</span>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
        <div v-else class="empty">暂无属性数据</div>
      </div>
    </div>
    <div v-if="['MODULE', 'SCHEME'].includes(resourceType) " class="version-info-right-part">
      <div class="basic-title">基本属性</div>
      <ul v-if="moduleBasicProps.length" class="family-parameters">
        <li v-for="property in moduleBasicProps" :key="property.id" class="property">
          <span class="property-name">{{ property.displayName }}</span>
          <span class="property-value">{{ property.displayValue || '-' }}</span>
        </li>
      </ul>
      <div v-else class="empty">暂无属性数据</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ViewCarousel from '@/components/business/resource/ViewCarousel.vue'
import Bimface from '@/components/common/Bimface.vue'
import NovaDesignThreeD from './NovaDesignThreeD.vue'
import PlaceholderTabContent from './PlaceholderTabContent.vue'
export default {
  name: 'VersionComponentInfo',
  components: { ViewCarousel, Bimface, NovaDesignThreeD, PlaceholderTabContent, },
  props: {
    resourceType: {
      type: String,
      default: 'COMPONENT'
    }
  },
  data() {
    return {
      currentTab: '2d',
      familyType: null,
      activeGroups: [0],
      familyParamsLoading: false,
      parameterLoading: false,
      viewToken: null,
      isNewThreeD: false

    }
  },
  computed: {
    ...mapGetters({
      currentResource: 'resourceDetail/currentResource',
      publicResourceInfo: 'resourceDetail/publicResourceInfo',
      versionResourceInfo: 'resourceDetail/versionResourceInfo',
      thumbnails: 'resourceDetail/thumbnails',
      parameterTypeOptions: 'resourceDetail/parameterTypeOptions',
      versionParameters: 'resourceDetail/versionParameters',
      parameterGeometryData: 'resourceDetail/parameterGeometryData',
      parameterCustomData: 'resourceDetail/parameterCustomData',
      parameterStandardGroups: 'resourceDetail/parameterStandardGroups',
      parameterGroups: 'resourceDetail/parameterGroups',
      buildInPlaceholders: 'resourceDetail/buildInPlaceholders',
    }),
    getThumbnails() {
      if (this.resourceType === 'MODULE') {
        return this.moduleThumbnails
      }
      if (this.resourceType === 'SCHEME') {
        return this.schemeThumbnails
      }
      if (this.thumbnails && this.thumbnails.length) {
        return [this.thumbnails[0]]
      }
      return ['@/assets/img/data_empty.png']
    },
    moduleThumbnails() {
      const generalThumbnails = this.versionResourceInfo.generalThumbnails || []
      if (this.resourceType === 'MODULE' && generalThumbnails.length) {
        const thumbnails = []
        const properties = this.publicResourceInfo.properties || []
        generalThumbnails.forEach((thumb) => {
          if (this.versionResourceInfo.softwareCode === 'AppGmep') {
            if (thumb.sizeMode === 'BIG' && thumb.viewType === 'VIEW3D') {
              thumbnails.push(this.$hosts.static(thumb.url))
            }
            return
          }
          if (thumb.sizeMode === 'LARGE' && (thumb.viewType === 'PLAN' || thumb.viewType === 'VIEW3D')) {
            if (properties.some((item) => item.value === '详图模块') && thumb.viewType === 'VIEW3D') {
              // 是详图模块并且是3D时，不做任何事情
            } else {
              thumbnails.push(this.$hosts.static(thumb.url))
            }
          }
        })
        return thumbnails
      }
      return []
    },
    schemeThumbnails() {
      const generalThumbnails = this.versionResourceInfo.generalThumbnails || []
      if (this.resourceType === 'SCHEME' && generalThumbnails.length) {
        return generalThumbnails.map((thumb) => {
          return this.$hosts.static(thumb.url)
        })
      }
      return []
    },
    moduleBasicProps() {
      return this.resourceType === 'MODULE' ? this.versionResourceInfo.properties?.filter((item) => !(item.code === 'MODULE_AREA_VALUE' && item.value === '0.0')) || [] : []
    },
    isNovaDesign() {
      return this.currentResource.platformCode === 'NOVA_DESIGN'
    },
    tabs() {
      const TabArr = [{ label: '缩略图', name: '2d', }]
      const threeDTab = { label: '3D', name: '3d', }
      const placeholderTab = { label: '图例', name: 'placeholder' }
      const platformCode = this.currentResource.platformCode
      const softwareCode = this.currentResource.softwareCode
      const buildInPlaceholders = this.buildInPlaceholders
      if (this.resourceType === 'COMPONENT') {
        if (this.isNovaDesign || ['revit', 'sketchup'].includes(softwareCode)) {
          TabArr.push(threeDTab)
        }
        if (platformCode === 'NOVA_DESIGN' && buildInPlaceholders.length) {
          // 软件看是否有内建图例，若有则显示图例tab
          TabArr.push(placeholderTab)
        }
      }
      return TabArr
    },
    showFamilyType() {
      return this.resourceType === 'COMPONENT' && ['NOVA_DESIGN', 'REVIT'].includes(this.currentResource.platformCode)
    },
    selectFamilyTypeName() {
      return this.familyType ? this.familyType.name : ''
    },
    propertyGroups() {
      const arr = this.isNovaDesign ? [
        {
          groupName: '几何属性',
          groupProperties: this.parameterGeometryData
        },
        ...this.parameterStandardGroups,
        {
          groupName: '自定义属性',
          groupProperties: this.parameterCustomData
        }
      ] : this.parameterGroups
      // 过滤掉groupProperties为空数组的分组
      return arr.filter((item) => item.groupProperties && item.groupProperties.length)
    },
    newThreeD() {
      if (this.publicResourceInfo.properties && this.publicResourceInfo.properties.length > 0) {
        return !this.publicResourceInfo.properties.some((f) => f.code === 'PERSONAL_MIGRATE' && f.value === '1')
      }
      return true
    }
  },
  watch: {
    parameterTypeOptions: {
      handler(newVal) {
        this.familyType = newVal && newVal.length ? newVal[0] : null
        if (this.familyType && this.familyType.id && this.currentResource.versionId) {
          this.parameterLoading = true
          this.loadVersionResourceParameterInfo({
            space_id: this.currentResource.spaceId,
            space_resource_id: this.currentResource.spaceResourceId,
            resource_software_version_id: this.currentResource.versionId,
            parameter_type_id: this.familyType.id
          }).finally(() => {
            this.parameterLoading = false
          })
        }
      },
      immediate: true,
    },
    'currentResource.softwareVersion': {
      handler() {
        this.currentTab = '2d'
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      loadVersionResourceParameterInfo: 'resourceDetail/loadVersionResourceParameterInfo',
      loadVersionResourceRelateInfo: 'resourceDetail/loadVersionResourceRelateInfo',
    }),
    changeView(tab) {
      this.currentTab = tab.name
      this.currentTabChange()
    },
    currentTabChange() {
      if (this.currentTab === '3d') {
        this.$tracks({
          event: '3DViewspaceComponent',
          params: {
            g_c_space_id: this.currentResource.spaceId,
            g_c_folder_id: this.currentResource.spaceResourceId,
          }
        })
        if (!this.isNovaDesign && !this.newThreeD) {
          this.getViewToken()
        }
      }
      if (this.currentTab === 'placeholder') {
        this.getRelatePlaceholders()
      }
    },
    getViewToken() {
      if (!this.viewToken) {
        this.$api.threeD.viewToken(this.currentResource.spaceResourceId).then((data) => {
          this.viewToken = data
        })
      }
    },
    // 获取关联图例
    getRelatePlaceholders() {
      // 有内嵌图例时，只展示内嵌图例
      if (this.buildInPlaceholders.length) { return }
      this.loadVersionResourceRelateInfo({
        space_id: this.currentResource.spaceId,
        space_resource_id: this.currentResource.spaceResourceId,
        resource_software_version_id: this.currentResource.versionId,
        language: this.currentResource.language,
      })
    },
    changeFamilyType() {
      this.parameterLoading = true
      this.loadVersionResourceParameterInfo({
        space_id: this.currentResource.spaceId,
        space_resource_id: this.currentResource.spaceResourceId,
        resource_software_version_id: this.currentResource.versionId,
        parameter_type_id: this.familyType.id
      }).finally(() => {
        this.parameterLoading = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.version-info-container{
  height: 680px;
  display: flex;
  flex-direction: row;
  border: 1px solid @border-color-tag;
  border-radius: 5px;
  .version-info-left-part{
    flex: 1;
  }
  .version-info-right-part{
    flex: 0 0 340px;
    margin-left: 0;
    border-left: 1px solid @border-color-tag;
  }
}
.tab-container{
  height: 620px;
  position: relative;
  .set-main-pic-icon{
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    z-index: 99;
  }
}
.family-select{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 16px;
  .family-label{
    flex: 0 0 40px;
    padding-right: 8px;
  }
  .family-value{
    flex: 1;
  }
}
.family-parameters{
  height: 612px;
  overflow: auto;
  .property{
    margin-top: 8px;
    font-size: 12px;
    display: flex;
    .property-name{
      text-align: right;
      padding-right:16px;
      color: rgba(73, 95, 112, 0.6);
      width: 40%;
    }
    .property-value{
      display: inline-block;
      flex-grow: 1;
      text-align: left;
      color: @text-tag-gery;
    }
  }
}
.empty{
  height: 100%;
  padding-top: 128px;
  text-align: center;
}
.basic-title{
  height: 40px;
  line-height: 40px;
  position: relative;
  padding: 0 10px;
  &:after{
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 339px;
    height: 1px;
    background-color: #D2D9E3;
  }
}
</style>
<style>
.detail-tab-container .el-tabs__nav-wrap::after{
  height: 1px !important;
  background-color: #D2D9E3;
}
.family-parameters .el-collapse-item__header {
  border: unset;
  border-top: 1px solid #D2D9E3;
  border-bottom: 1px solid #D2D9E3;
}
</style>
